import { BaseRouteService } from 'core/services';

class VerificationRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-verification/';
	}

	sendVerificationCode = sendVerificationCodeParams => {
		return super.update(this.base + 'send-code', sendVerificationCodeParams);
	};

	validateVerificationCode = validateVerificationCodeParams => {
		return super.update(this.base + 'validate-code', validateVerificationCodeParams);
	};
}

export default VerificationRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/VerificationRouteService.js